import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import defaultLocale from '../../../i18n/en';
var locales = {
  cs: function cs() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-cs" */'../../../i18n/cs');
  },
  da: function da() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-da" */'../../../i18n/da');
  },
  de: function de() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-de" */'../../../i18n/de');
  },
  'en-GB': function enGB() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en_GB" */'../../../i18n/en_GB');
  },
  'en-ZZ': function enZZ() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en_ZZ" */'../../../i18n/en_ZZ');
  },
  en: function en() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-en" */'../../../i18n/en');
  },
  es: function es() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-es" */'../../../i18n/es');
  },
  fi: function fi() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-fi" */'../../../i18n/fi');
  },
  fr: function fr() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-fr" */'../../../i18n/fr');
  },
  hu: function hu() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-hu" */'../../../i18n/hu');
  },
  it: function it() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-it" */'../../../i18n/it');
  },
  ja: function ja() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ja" */'../../../i18n/ja');
  },
  ko: function ko() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ko" */'../../../i18n/ko');
  },
  nb: function nb() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-nb" */'../../../i18n/nb');
  },
  nl: function nl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-nl" */'../../../i18n/nl');
  },
  pl: function pl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-pl" */'../../../i18n/pl');
  },
  'pt-BR': function ptBR() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-pt_BR" */'../../../i18n/pt_BR');
  },
  ru: function ru() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */'../../../i18n/ru');
  },
  sl: function sl() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */'../../../i18n/sl');
  },
  sr_RS: function sr_RS() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */'../../../i18n/sr_RS');
  },
  sr_YR: function sr_YR() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-ru" */'../../../i18n/sr_YR');
  },
  sv: function sv() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-sv" */'../../../i18n/sv');
  },
  th: function th() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-th" */'../../../i18n/th');
  },
  tr: function tr() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-tr" */'../../../i18n/tr');
  },
  uk: function uk() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-uk" */'../../../i18n/uk');
  },
  vi: function vi() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-vi" */'../../../i18n/vi');
  },
  zh_TW: function zh_TW() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-zh_TW" */'../../../i18n/zh_TW');
  },
  zh: function zh() {
    return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/browser-storage-controls-i18n-zh" */'../../../i18n/zh');
  }
};
export var fetchMessagesForLocale = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locale) {
    var messages, parentLocale, _messages;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return locales[locale]();
        case 3:
          messages = _context.sent;
          return _context.abrupt("return", messages.default);
        case 7:
          _context.prev = 7;
          _context.t0 = _context["catch"](0);
        case 9:
          _context.prev = 9;
          parentLocale = locale.split(/[-_]/)[0];
          _context.next = 13;
          return locales[parentLocale]();
        case 13:
          _messages = _context.sent;
          return _context.abrupt("return", _messages.default);
        case 17:
          _context.prev = 17;
          _context.t1 = _context["catch"](9);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 7], [9, 17]]);
  }));
  return function fetchMessagesForLocale(_x) {
    return _ref.apply(this, arguments);
  };
}();
export { defaultLocale };